import { render, staticRenderFns } from "./ReportQuotes.vue?vue&type=template&id=620404ec&scoped=true&"
import script from "./ReportQuotes.vue?vue&type=script&lang=js&"
export * from "./ReportQuotes.vue?vue&type=script&lang=js&"
import style0 from "./ReportQuotes.vue?vue&type=style&index=0&id=620404ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620404ec",
  null
  
)

export default component.exports